import {
  waltloo_dashboard_id,
  atteridgville_dashboard_id,
  lesedi_dashboard_id
} from '@/config/dashboardIds';

export default function getTilesConfiguration() {
  const SERVICE_PROVIDER_LIST = [
    { name: "City Power", category: "Electricity", phone: "086 000 7788", icon: "bi bi-lightning-charge-fill" },
    { name: "Johannesburg Water", category: "Water & Sanitation", phone: "011 688 2500", icon: "bi bi-droplet-fill" },
    { name: "Afrox Gas", category: "Gas Supply", phone: "086 022 3300", icon: "bi bi-fire" },
    { name: "Vumatel", category: "Fibre Internet", phone: "087 820 9000", icon: "bi bi-wifi" },
    { name: "Fidelity ADT", category: "Security Response", phone: "086 013 4354", icon: "bi bi-shield-lock-fill" },
    { name: "Vuma Cam", category: "CCTV Monitoring", phone: "010 500 3000", icon: "bi bi-camera-video-fill" },
    { name: "Engen Fleet", category: "Diesel Supply", phone: "086 010 1010", icon: "bi bi-truck" }
  ];

  return [
    {
      id: 'Rivergate City Shopping Centre (Live)',
      title: 'Rivergate City Shopping Centre',
      stats: 'Energy Efficiency 91%',
      description: 'Shopping Centre',
      trend: '+2.8%',
      dashboardId: lesedi_dashboard_id,
      coordinates: { lat: -26.354546849182338, lng: 28.197169881076025 },
      propertyOverview: { size: '8,240 mÂ²', occupancy: '94%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Vosloorus Precinct",
        stationContact: "011 861 6600",
        crimeIndex: "Medium",
        periodIncrease: "8% decrease from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 7, trend: "-8%" },
          { category: "Theft from Vehicle", count: 4, trend: "-12%" },
          { category: "Assault", count: 2, trend: "0%" },
          { category: "Burglary", count: 1, trend: "-18%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://forum.vosloorus-community.co.za"
      },
      tileCards: [
        {
          id: 'Rivergate-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Vosloorus, Johannesburg, 1475',
            hours: 'Centre Manager: Mon-Fri 8am-5pm',
            website: 'N/A',
            phone: 'N/A',
            email: 'N/A'
          }
        },
        {
          id: 'Rivergate-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Rivergate City Shopping Centre',
          coordinates: { lat: -26.354546849182338, lng: 28.197169881076025 }
        },
        {
          id: 'Rivergate-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Grupo Antolin',
      title: 'Grupo Antolin (Waltloo)',
      stats: 'Energy Efficiency 85%',
      description: 'Shopping Centre',
      trend: '+2.1%',
      dashboardId: waltloo_dashboard_id,
      coordinates: { lat: -25.73480830192779, lng: 28.327896695979607 },
      propertyOverview: { size: '7,360 m²', occupancy: '92%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Vosloorus Precinct",
        stationContact: "011 861 6600",
        crimeIndex: "High",
        periodIncrease: "14% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 12, trend: "-5%" },
          { category: "Theft from Vehicle", count: 8, trend: "+10%" },
          { category: "Assault", count: 4, trend: "0%" },
          { category: "Burglary", count: 3, trend: "-15%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://forum.vosloorus-community.co.za"
      },
      tileCards: [
        {
          id: 'Waltloo-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Mc Botha Dr, Vosloorus, Johannesburg, 1475',
            hours: 'Phindile Tsotetsi: Mon-Fri 8am-5pm',
            website: 'N/A',
            phone: '066 136 7815',
            email: 'N/A'
            }
        },
        {
          id: 'Waltloo-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Global Antolin(Waltloo)',
          coordinates: { lat: -26.354546849182338, lng: 28.197169881076025 }
        },
        {
          id: 'Waltloo-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Atteridgville Waste Center',
      title: 'Atteridgville Waste Center',
      stats: 'Energy Efficiency 93%',
      description: 'Retail Centre',
      trend: '+3.1%',
      dashboardId: atteridgville_dashboard_id,
      coordinates: { lat: -25.780972472588992, lng: 28.046205740388874 },
      propertyOverview: { size: '6,468 m²', occupancy: '98%', description: 'Retail Centre' },
      crimeStats: {
        precinct: "Kenton-On-Sea",
        stationContact: "046 648 1234",
        crimeIndex: "Medium",
        periodIncrease: "12% decrease from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 6, trend: "-15%" },
          { category: "Theft from Vehicle", count: 3, trend: "-20%" },
          { category: "Assault", count: 2, trend: "-10%" },
          { category: "Burglary", count: 1, trend: "-25%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://kentonsea-community.co.za"
      },
      tileCards: [
        {
          id: 'Atteridgville-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: '1355 Kariega Rd, Kenton-on-Sea, 6191',
            hours: 'Zimkihita: Mon-Fri 8am-5pm',
            website: 'N/A',
            phone: '083 246 3531',
            email: 'N/A'
          }
        },
        {
          id: 'Atteridgville-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Ekumphumleni Retail Centre',
          coordinates: { lat: -33.679000387909795, lng: 26.667498296251875 }
        },
        {
          id: 'Atteridgville-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    }
  ];
}
